import $ from 'jquery';

function calculate(params) {
  const { value, baseUrl, investorId, vendorId, customFee, investmentId } = params;
  const url = `${baseUrl}/${value}`;
  $.ajax({
    method: "GET",
    url: url,
    data: {
      investor_id: investorId,
      vendor_id: vendorId,
      custom_fee: customFee,
      investment_id: investmentId,
    },
  })
    .done(function(response) {
      $("#investment_quantity").val(response.stocks.toString());
      $("#stocksValue").val(response.sum.toString());
      $("#stockPricePer").val(response.stock_price_per.toString());
      $("#maxStocksValue").val(response.max_stocks.toString());
      $("#salesChargePercent").val(response.fee_percentage.toString());
      $("#salesCharge").val(response.fee.toString());
      $("#totalCharge").val(response.total.toString());
      $("#subTotalCharge").html(response.sub_total.toString() + " €");
      $("#investment_fee_discount").html("-" + response.discountAmount.toString() + " €");
      $("#shareStatusNotification").html(response.share_status_notification.toString());
      $("#shareMaxSharesNotification").html(response.share_max_shares_notification.toString());
    })
    .fail(function(response) {
      console.error(response);
    });
}

function isValueLowerThanAllowedQuantity(value) {
  if (KR.has_previous_investments_for_round) {
    return value < KR.quantity_step;
  } else {
    return value < KR.min_quantity;
  }
}

function changeQuantityStepDown(value, amount, single_deal_quantity) {
  value = value + amount;
  if (isValueLowerThanAllowedQuantity(value)) {
    $("#investment_quantity").val(single_deal_quantity);
  } else {
    $("#investment_quantity").val(value);
  }
  callCalculate();
}

function changeQuantityStepUp(value, amount) {
  if (value === KR.single_deal_quantity) {
    // minimum bump to be updated to the next valid value by the backend
    $("#investment_quantity").val(value + 1);
  } else {
    $("#investment_quantity").val(value + amount);
  }
  callCalculate();
}

// Investor calculation
$(document).on("turbo:load", function() {
  if ($("#calculator").length) {
    var baseUrl = $("#investment_quantity").data("url");

    if ($("#investment_quantity").val()) {
      callCalculate();
    };

    $("#investment_quantity").change(function() {
      callCalculate();
    });

    $(".number-picker-up").click(function() {
      var value = parseInt($("#investment_quantity").val());
      var step = Math.abs(KR.quantity_step);
      changeQuantityStepUp(value, step);
    });
    $(".number-picker-down").click(function() {
      var value = parseInt($("#investment_quantity").val());
      changeQuantityStepDown(value, -Math.abs(KR.quantity_step), KR.single_deal_quantity);
    });
  }
});

function callCalculate() {
  var baseUrl = $("#investment_quantity").data("url");
  var value = parseInt($("#investment_quantity").val());
  var investmentId = $("#investment_id").val();

  calculate({
    value: value,
    baseUrl: baseUrl,
    investorId: null,
    vendorId: null,
    customFee: null,
    investmentId: investmentId,
  });
}

// Admin calculation
function collectAdminFields() {
  var value = parseInt($("#investment_quantity").val());
  var roundId = $("#investment_round_id").val();
  var investorId = $("#investment_user_id").val();
  var vendorId = $("#investment_agreement_attributes_vendor_id").val();
  var customFee =  $("#investment_custom_fee").val();
  if (investorId && roundId && vendorId) {
    var baseUrl = "/rounds/" + roundId + "/calculate";
    calculate({
      value: value,
      baseUrl: baseUrl,
      investorId: investorId,
      vendorId: vendorId,
      customFee: customFee,
      investmentId: null,
    });
  }
}

$(document).on("turbo:load", function() {
  if ($("#calculator-admin").length) {
    checkCustomFeeValue();
    collectAdminFields();
    $(
      "#investment_quantity, #investment_round_id, #investment_user_id, #investment_agreement_attributes_vendor_id, #investment_custom_fee"
    ).change(function() {
      checkCustomFeeValue();
      collectAdminFields();
    });
  }
});

function checkCustomFeeValue() {
  $("#investment_custom_fee").change(function() {
    var customFee = $("#investment_custom_fee").val();
    if (customFee < 0.0) {
      $("#investment_custom_fee").val(0.0);
    } else if (customFee > 100.0) {
      $("#investment_custom_fee").val(100.0);
    } else {
      $("#investment_custom_fee").val(parseFloat(customFee).toFixed(2));
    }
  });
}

// TODO refactor js
// Calculate share numbers for Admin Round form and Share Ownership form
$(document).on("turbo:load", function() {
  // for Admin Round form
  $("#round_share_number_min").change(function() {
    calculateAdminShareNumberRange();
  });

  $("#round_max_target_quantity").change(function() {
    $("#round_share_number_min").removeAttr("disabled");
    calculateAdminShareNumberRange();
  });

  var calculateAdminShareNumberRange = function() {
    var max_quantity = parseInt($("#round_max_target_quantity").val());
    var share_number_min = parseInt($("#round_share_number_min").val());
    var share_max_number = share_number_min + (max_quantity - 1);

    if (isNaN(share_number_min)) {
      $("#round_share_number_max").val("");
    } else if (isNaN(max_quantity)) {
      $("#round_share_number_max").val("");
    } else {
      $("#round_share_number_max")
        .val(share_max_number)
        .val();
    }
  };

  // Share Ownership form
  $("#share_ownership_share_number_min").change(function() {
    calculateShareNumberRange();
  });

  $("#share_ownership_quantity").change(function() {
    $("#share_ownership_share_number_min").removeAttr("disabled");
    calculateShareNumberRange();
  });

  var calculateShareNumberRange = function() {
    var max_quantity = parseInt($("#share_ownership_quantity").val());
    var share_number_min = parseInt($("#share_ownership_share_number_min").val());
    var share_max_number = share_number_min + (max_quantity - 1);

    if (isNaN(share_number_min)) {
      $("#share_ownership_share_number_max").val("");
    } else if (isNaN(max_quantity)) {
      $("#share_ownership_share_number_max").val("");
    } else {
      $("#share_ownership_share_number_max")
        .val(share_max_number)
        .val();
    }
  };
});
